import { render, staticRenderFns } from "./Rejections.vue?vue&type=template&id=6d8d9138"
import script from "./Rejections.vue?vue&type=script&lang=js"
export * from "./Rejections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports